import React, { useState } from 'react';

const Gallery = () => {
  const [activeFilter, setActiveFilter] = useState('All');
  const [lightbox, setLightbox]         = useState(null);

  const images = [
    { src: 'https://images.unsplash.com/photo-1551218808-94e220e084d2?w=900&q=90',  cat: 'Ambiance' },
    { src: 'https://images.unsplash.com/photo-1563379091339-03246963d4c5?w=700&q=85', cat: 'Food'    },
    { src: 'https://images.unsplash.com/photo-1585032226651-759b368d7246?w=700&q=85', cat: 'Food'    },
    { src: 'https://images.unsplash.com/photo-1541599468348-e96984315621?w=900&q=90', cat: 'Food'    },
    { src: 'https://images.unsplash.com/photo-1579584425555-c3ce17fd4351?w=700&q=85', cat: 'Dim Sum' },
    { src: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=700&q=85', cat: 'Ambiance'},
    { src: 'https://images.unsplash.com/photo-1563245372-f21724e3856d?w=700&q=85',    cat: 'Ambiance'},
    { src: 'https://images.unsplash.com/photo-1428515613728-6b4607e44363?w=900&q=90', cat: 'Food'    },
    { src: 'https://images.unsplash.com/photo-1455619452474-d2be8b1e70cd?w=700&q=85', cat: 'Food'    },
  ];

  const filters = ['All', 'Food', 'Ambiance', 'Dim Sum'];
  const filtered = activeFilter === 'All' ? images : images.filter(img => img.cat === activeFilter);

  return (
    <div className="bg-ink min-h-screen">

      {/* ── Page Hero ─────────────────────────────────── */}
      <section className="relative h-80 flex items-end overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=1600&q=85"
          alt="Gallery"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/65 to-ink/10"></div>
        <div className="lattice-pattern absolute inset-0 opacity-[0.04]"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 w-full pb-14">
          <div className="flex items-center gap-4 mb-3">
            <div className="h-px w-8 bg-warm-gold"></div>
            <span className="text-warm-gold text-xs tracking-[0.4em] uppercase">A Feast for the Eyes</span>
          </div>
          <h1 className="font-serif text-6xl md:text-7xl text-white leading-none">
            Our <span className="text-gradient-gold">Gallery</span>
          </h1>
        </div>
      </section>

      {/* ── Filter Bar ────────────────────────────────── */}
      <div className="max-w-7xl mx-auto px-6 pt-12 pb-8">
        <div className="flex gap-2 flex-wrap">
          {filters.map(f => (
            <button
              key={f}
              onClick={() => setActiveFilter(f)}
              className={`px-6 py-2 text-xs tracking-[0.2em] uppercase transition-all duration-300 ${
                activeFilter === f
                  ? 'bg-imperial-red text-white'
                  : 'border border-white/15 text-white/50 hover:border-warm-gold/50 hover:text-warm-gold'
              }`}
            >
              {f}
            </button>
          ))}
          <span className="ml-auto self-center text-white/20 text-xs tracking-widest uppercase">
            {filtered.length} Photos
          </span>
        </div>
      </div>

      {/* ── Masonry Grid ──────────────────────────────── */}
      <div className="max-w-7xl mx-auto px-6 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 space-y-4">
          {filtered.map((img, index) => (
            <div
              key={index}
              className="relative group overflow-hidden break-inside-avoid cursor-pointer"
              onClick={() => setLightbox(img.src)}
            >
              <img
                src={img.src}
                alt={`Gallery ${index + 1}`}
                className="w-full object-cover transition-transform duration-700 group-hover:scale-106 block"
                style={{ transition: 'transform 0.6s ease' }}
              />
              {/* Hover Overlay */}
              <div className="absolute inset-0 bg-charcoal/0 group-hover:bg-charcoal/60 transition-all duration-500 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-400 text-center">
                  <div className="w-12 h-12 border border-warm-gold flex items-center justify-center mx-auto mb-3">
                    <span className="text-warm-gold text-lg">✦</span>
                  </div>
                  <span className="text-white text-xs tracking-[0.3em] uppercase">{img.cat}</span>
                </div>
              </div>
              {/* Category ribbon */}
              <div className="absolute top-3 right-3 bg-imperial-red/80 text-white text-xs px-2.5 py-1 tracking-widest uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                {img.cat}
              </div>
              {/* Gold bottom bar */}
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-warm-gold transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Lightbox ──────────────────────────────────── */}
      {lightbox && (
        <div
          className="fixed inset-0 z-50 bg-ink/95 flex items-center justify-center p-6 cursor-pointer"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-8 text-warm-gold text-3xl hover:text-white transition-colors"
            onClick={() => setLightbox(null)}
          >
            ✕
          </button>
          <img
            src={lightbox}
            alt="Enlarged view"
            className="max-w-full max-h-[85vh] object-contain border border-warm-gold/20"
            onClick={e => e.stopPropagation()}
          />
        </div>
      )}
    </div>
  );
};

export default Gallery;
